import { AIModelChoices } from 'api';

export type AiPetModels =
  | typeof AIModelChoices.pet
  | typeof AIModelChoices.pet_dummy_bale
  | typeof AIModelChoices.pet_dummy_bale_2
  | typeof AIModelChoices.pet_envases
  | typeof AIModelChoices.pet_loose;
export type AiPetBaledModels =
  | typeof AIModelChoices.pet
  | typeof AIModelChoices.pet_dummy_bale
  | typeof AIModelChoices.pet_dummy_bale_2
  | typeof AIModelChoices.pet_envases;
export type AiAluModels = typeof AIModelChoices.alu | typeof AIModelChoices.alu_loose | typeof AIModelChoices.briquette;
export type AiOtherModels = typeof AIModelChoices.other;
export type AiHdpeModels = typeof AIModelChoices.hdpe;
export type AiLooseModels = typeof AIModelChoices.alu_loose | typeof AIModelChoices.pet_loose;
export type AiNonLooseModels =
  | typeof AIModelChoices.alu
  | typeof AIModelChoices.pet
  | typeof AIModelChoices.pet_dummy_bale
  | typeof AIModelChoices.pet_dummy_bale_2
  | typeof AIModelChoices.pet_envases
  | typeof AIModelChoices.briquette
  | typeof AIModelChoices.hdpe;

export const isLooseAiModel = (model?: AIModelChoices): model is AiLooseModels =>
  model === AIModelChoices.alu_loose || model === AIModelChoices.pet_loose;

export const isPetAiModel = (model?: AIModelChoices): model is AiPetModels =>
  model === AIModelChoices.pet ||
  model === AIModelChoices.pet_dummy_bale ||
  model === AIModelChoices.pet_dummy_bale_2 ||
  model === AIModelChoices.pet_envases ||
  model === AIModelChoices.pet_loose;

export const isPetBaledAiModel = (model?: AIModelChoices): model is AiPetBaledModels =>
  isPetAiModel(model) && !isLooseAiModel(model);

export const isAluAiModel = (model?: AIModelChoices): model is AiAluModels =>
  model === AIModelChoices.alu || model === AIModelChoices.briquette || model === AIModelChoices.alu_loose;

export const isOtherAiModel = (model?: AIModelChoices): model is AiOtherModels => model === AIModelChoices.other;

export const isHdpeAiModel = (model?: AIModelChoices): model is AiHdpeModels => model === AIModelChoices.hdpe;
